import React from "react";
import PropTypes from "prop-types";
import Container from "react-bootstrap/Container";
import "./style.scss";
import placeholder from "../../..//assets/images/placeholder.svg";

//import components
import Input from "../../elements/input/Input";
import Button from "../../elements/button/Button";

const GetFreeOffer = () => {
  return (
    <div className="get_free_offer">
      <Input placeholder="Enter your store website" type="text" />
      <Button>Get My Free Offer</Button>
    </div>
  );
};
const CallToActionSection = ({ actionList }) => {
  return (
    <div className="call-to-action">
      {actionList &&
        actionList.map((item) => <ActionItem key={item.id} {...item} />)}
    </div>
  );
};
const ActionItem = ({ title, text, placeholder }) => {
  return (
    <div className="action__item">
      <div className="image-holder">
        <img src={placeholder} alt="action_placeholder" />
      </div>
      <div className="details">
        <h3 className="title">{title}</h3>
        <p className="text">{text}</p>
      </div>
    </div>
  );
};
const Header = ({ largeText, subText }) => {
  const actions = [
    {
      id: 1,
      placeholder,
      title: "Get an offer in 1 day",
      text:
        "Skip the long process and expensive fees. It’s free and easy to \nfind out the value of your business.",
    },
    {
      id: 2,
      placeholder,
      title: "Cash out on your schedule",
      text:
        "Walk away with the money you earned in days, not months. Our \ntechnology does the heavy-lifting for you.",
    },
    {
      id: 3,
      placeholder,
      title: "Pursue your next dream",
      text:
        "Get paid for the hard work you put into your business and be \nfree to focus on what’s next.",
    },
  ];
  return (
    <header className="header masthead">
      <Container>
        <h1 className="header-text">{largeText}</h1>
        <p className="header-sub-text">{subText}</p>

        <GetFreeOffer />
        <CallToActionSection actionList={actions} />
      </Container>
    </header>
  );
};

Header.propTypes = {
  largeText: PropTypes.string,
  subText: PropTypes.string,
};
Header.defaultProps = {
  largeText: "Get money for what’s next",
  subText: "Sell your e-commerce business to OpenStore. It’s fast and easy.",
};

export default Header;
